import { TDay } from 'src/api/getMenu/types';
import { IMealtime, ISchedule } from 'src/types/mealtimes.types';

// [[start_time, end_time], ...] - get all enabled intervals for the same day

export const getSchedulesTimes = (day: TDay, mealtimes: IMealtime[]): string[][] =>
  mealtimes.reduce((acc: string[][], currentValue: IMealtime) => {
    const enabledSchedule = currentValue.schedules.find(
      (schedule: ISchedule) => schedule.day_of_week === day && schedule.enabled,
    );

    return enabledSchedule ? [...acc, [enabledSchedule.start_time, enabledSchedule.end_time]] : acc;
  }, []);
